import { render, staticRenderFns } from "./RegBsCollFromNuForm.vue?vue&type=template&id=2dc9ab30&scoped=true&"
import script from "./RegBsCollFromNuForm.vue?vue&type=script&lang=js&"
export * from "./RegBsCollFromNuForm.vue?vue&type=script&lang=js&"
import style0 from "./RegBsCollFromNuForm.vue?vue&type=style&index=0&id=2dc9ab30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc9ab30",
  null
  
)

export default component.exports